import { render, staticRenderFns } from "./schoolManagement.vue?vue&type=template&id=255d6eb0&scoped=true"
import script from "./schoolManagement.vue?vue&type=script&lang=js"
export * from "./schoolManagement.vue?vue&type=script&lang=js"
import style0 from "./schoolManagement.vue?vue&type=style&index=0&id=255d6eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255d6eb0",
  null
  
)

export default component.exports